import { MainMenuLink, SwitchLink } from '@type/header-types';
import { BriefcaseIcon } from '@heroicons/react/20/solid';

// MAIN MENU LINKS
// forRole:
// NONE - for all, when they are not logged-in
// USER - for authenticated users with role 'USER'
// COMPANY - for authenticated users with role 'COMPANY'

// type:
// symfony - link to symfony route
// react - link to react route
// external - link to external route

// forSection
// TALENT - Represents the talent-related section.
// HIRE - Represents the hiring-related section.
// *******************************************************************

export const mainMenuLinks: MainMenuLink[] = [
  {
    // MyJobs+ is a plain link now — its former dropdown entries (add job, cv search,
    // pricing, support) all live on the my-jobs page top bar.
    route: '/my-jobs',
    label: 'mc.chip.my.jobs',
    type: 'react',
    forSection: ['TALENT', 'HIRE'],
    onlyMobile: false,
    icon: BriefcaseIcon,
    dataTestId: 'navbar-my-jobs',
  },
  {
    route: '/job-add/edit',
    label: 'mc.chip.add',
    type: 'react',
    forSection: ['TALENT', 'HIRE'],
    onlyMobile: false,
    dataTestId: 'navbar-add-job',
  },
];


// SWITCH LINK - between company and user
// *******************************************************************
export const switchLink: SwitchLink = {
  notAuth: { // to add job
    route: '/job-add/edit',
    label: 'header.label.add_jobs',
  },
  authUser: { // change to company account
    route: 'account_user_type',
    label: 'header.switch.hire',
  },
  authCompany: { // change to user account
    route: 'account_user_type',
    label: 'header.switch.work',
  },
};
